/**
 * i18n setup for VSMS — Hindi (hi), Marathi (mr), Tamil (ta), English (en).
 *
 * Translations cover the highest-traffic UI surfaces:
 *   - Landing page hero
 *   - Login page
 *   - Sidebar nav labels
 *   - Common buttons + actions (Save, Cancel, Delete, etc.)
 *   - Parent home tabs + key labels
 *   - Status badges + system messages
 *
 * Other pages fall back to English (a deliberate pragmatic choice — the
 * codebase has ~50 pages; full coverage is a multi-day project).
 *
 * Storage: language preference is saved to `vs-i18n-lang` localStorage key.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import hi from "./locales/hi.json";
import mr from "./locales/mr.json";
import ta from "./locales/ta.json";

export const SUPPORTED_LANGS = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "mr", label: "Marathi", native: "मराठी" },
  { code: "ta", label: "Tamil", native: "தமிழ்" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      mr: { translation: mr },
      ta: { translation: ta },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "vs-i18n-lang",
    },
  });

export default i18n;
